import React from "react"
import { FormattedMessage, } from "react-intl"

export const renderConfigurationLabel = (label: string) => {
    switch (label) {
    case "listId":
        return <FormattedMessage
            id="integration.form.mailchimp.list_id"
            defaultMessage="List"
        />
    case "storeId":
        return <FormattedMessage
            id="integration.form.mailchimp.store_id"
            defaultMessage="Store"
        />
    default:
        return label
    }
}

export const renderToggleLabel = (label: string) => {
    switch (label) {
    case "contact-export":
        return <FormattedMessage
            id="integration.form.mailchimp.enable_contact_export_feature"
            defaultMessage="Enable contact export"
        />
    case "proposed-quote-export":
        return <FormattedMessage
            id="integration.form.mailchimp.enable_proposed_quote_export_feature"
            defaultMessage="Enable quote export"
        />
    case "sent-invoice-export":
        return <FormattedMessage
            id="integration.form.mailchimp.enable_sent_invoice_export_feature"
            defaultMessage="Enable invoice export"
        />
    case "exportAsSubscribed":
        return <FormattedMessage
            id="integration.form.mailchimp.export_as_subscribed"
            defaultMessage="Export contacts as subscribed"
        />
    default:
        return label
    }
}




// WEBPACK FOOTER //
// ./src/utils/integration/mailchimp/utils.tsx